<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import PeopleModal from "people-modal";

export default {
  mixins: [fandomBasicMixin],
  components: {
    PeopleModal
  },
  props: {
    componentClass: {
      type: String,
      default: "container"
    }
  },
  data: function () {
    return {
      popupOpen: false
    };
  },
  computed: {
    areArrowsVisible() {
      return !(globalState.viewport.sm || globalState.viewport.xs);
    },
    columnClasses() {
      const classes = [];
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      classes.push(`col-lg-${columnWidth}`);
      return classes;
    },
    memberColumnClasses() {
      if (this.content.members.length > 1) {
        return "col-lg-6";
      } else {
        return "col-12";
      }
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentType, componentClass]" class="py-2" v-if="isContentVisibleToUser()" table-people-component>
    <div class="row justify-content-center">
      <div :class="columnClasses">
        <div class="row border-right border-bottom mx-0 align-items-center">
          <div :class="memberColumnClasses" class="border-top border-left px-0" v-for="(member,index) in content.members">
            <people-modal :content="member" :optContainerContent="containerContent">
              <div class="p-3 member d-flex justify-content-begin align-items-center">
                <div class="member-photo">
                  <div class="ar-1by1 bg-cover-center rounded-circle" :title="member.member_name" :style="{'background-image': `url(${member.member_photo.url})`}"></div>
                </div>
                <div class="d-flex flex-column justify-content-center mx-3 member-description">
                  <h3 class="text-uppercase member-name mb-2 h4">{{member.member_name}}</h3>
                  <small class="mb-0" v-html="member.member_role"></small>
                </div>
                <div v-if="areArrowsVisible" class="text-right flex-grow-1 member-arrow">
                  <i class="fal fa-long-arrow-right"></i>
                </div>
              </div>
            </people-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[table-people-component] {

  .member {
    cursor: pointer;
    color: $dark;
    text-decoration: none;

    .fal {
      font-size: 1.5rem;
      position: relative;
      right: 1.5rem;
      transition: right .5s;
    }

    &:hover {
      .fal {
        right: 0rem;
      }
    }

    .member-arrow {
      width: 3rem;
    }

    .member-photo > div {
      width: 5rem;
    }

    .member-name {
      letter-spacing: 1.2px;
      font-weight: 600;
    }

    .member-role {
      font-size: 1rem;
      font-weight: 300;
    }

    .member-description {
      min-width: 50%;
    }

  }
}

</style>